import {useState} from 'react';
import {commitTicketingMutation} from '../../../graphql/forecastRelay';
import UnlinkForecastTaskFromTicketMutation from '../../../../../mutations/ticketing/tickets/unlinkForecastTaskFromTicketMutation';

export interface UnlinkForecastTaskInput {
	ticketId: string;
	forecastTaskId: string;
}

export function useUnlinkForecastTaskFromTicket() {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<string | null>(null);

	function submit(input: UnlinkForecastTaskInput) {
		setError(null);
		setLoading(true);
		return new Promise((resolve, reject) => {
			commitTicketingMutation(
				UnlinkForecastTaskFromTicketMutation,
				input,
				response => {
					setLoading(false);
					resolve(response.unlinkForecastTaskFromTicket.ticket);
				},
				err => {
					setLoading(false);
					setError(err instanceof Error ? err.message : String(err));
					reject(err);
				}
			);
		});
	}

	return {submit, loading, error};
}
